import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import MainCard from "components/MainCard";

interface ExpandingOrderDetailProps {
  data: Order;
}

const ExpandingOrderDetail = ({ data }: ExpandingOrderDetailProps) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      spacing={3.5}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={7} md={12} xl={8.5}>
        <Stack spacing={2.5}>
          <MainCard title="Order Details">
            <List sx={{ py: 0 }}>
              {/* Top-level order info */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Order ID</Typography>
                      <Typography>{data.id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Company Name</Typography>
                      <Typography>{data.company_name}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">User ID</Typography>
                      <Typography>{data.user_id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Payment ID</Typography>
                      <Typography>{data.payment_id}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Urgent</Typography>
                      <Typography>{data.urgent}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Status</Typography>
                      <Typography>{data.status}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Total Price</Typography>
                      <Typography>{data.total_price}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Created At</Typography>
                      <Typography>{data.created_at}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Updated At</Typography>
                      <Typography>{data.updated_at}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* {data.order_items.map((item, index) => (
                <ListItem
                  key={item.id}
                  divider={!matchDownMD}
                  sx={{ flexDirection: "column", alignItems: "flex-start" }}
                >
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    Order Item #{index + 1}
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={0.5}>
                        <Typography color="secondary">Order Item ID</Typography>
                        <Typography>{item.id}</Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={0.5}>
                        <Typography color="secondary">Packable Type</Typography>
                        <Typography>{item.packable_type}</Typography>
                      </Stack>
                    </Grid>

                    {Object.entries(item.packable).map(([key, value]) => (
                      <Grid item xs={12} md={6} key={key}>
                        <Stack spacing={0.5}>
                          <Typography color="secondary">
                            {key.replace(/_/g, " ")}
                          </Typography>
                          <Typography>{String(value)}</Typography>
                        </Stack>
                      </Grid>
                    ))}

                    {Object.entries(item.meta).map(([key, value]) => (
                      <Grid item xs={12} md={6} key={key}>
                        <Stack spacing={0.5}>
                          <Typography color="secondary">
                            {key.replace(/_/g, " ")}
                          </Typography>
                          <Typography>{String(value)}</Typography>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </ListItem>
              ))} */}
            </List>
          </MainCard>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ExpandingOrderDetail;
